import { gql } from '@apollo/client';

export const DELETE_SURROUNDING_INFORMATION_CATEGORY_MUTATION = gql`
  mutation DeleteSurroundingInformationCategory($id: ID!) {
    deleteSurroundingInformationCategory(input: { where: { id: $id } }) {
      surroundingInformationCategory {
        id
      }
    }
  }
`;
